/* Product page — variant picker, gallery sync, subtotal, vehicle prefill, sticky bar. */
(function () {
  'use strict';
  var W = window.WWC;
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var form = document.getElementById(root.dataset.form);
    if (!form) return;
    var idInput = form.querySelector('[data-variant-id]');
    var dataEl = root.querySelector('[data-variants]');
    var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
    var track = root.querySelector('[data-gallery-track]');
    var atc = form.querySelector('[data-atc]'), atcLabel = form.querySelector('[data-atc-label]');
    var atcText = (atc && atc.dataset.atcText) || (atcLabel ? atcLabel.textContent : '');
    var soldText = (atc && atc.dataset.soldOut) || 'Unavailable';
    var current = variants.filter(function (v) { return v.id === +idInput.value; })[0] || null;

    /* ----- variant selection ----- */
    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('.pdp-option[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function mark() {
      // grey out values that can't form an available variant with the other picks
      var sel = selected();
      root.querySelectorAll('.pdp-option[data-option-index]').forEach(function (fs) {
        var i = +fs.dataset.optionIndex;
        fs.querySelectorAll('input').forEach(function (inp) {
          var ok = variants.some(function (v) { return v.available && v.options[i] === inp.value && v.options.every(function (o, j) { return j === i || o === sel[j]; }); });
          inp.nextElementSibling.classList.toggle('is-unavailable', !ok);
        });
        var lab = fs.querySelector('[data-option-value]'); if (lab) lab.textContent = sel[i] || '';
      });
    }
    function onChange() {
      var sel = selected();
      current = variants.filter(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); })[0] || null;
      if (current) {
        idInput.value = current.id;
        var u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState(null, '', u.toString());
        var pw = root.querySelector('[data-price]'); if (pw) pw.textContent = W.money(current.price);
        var cmp = root.querySelector('[data-compare]'); if (cmp) cmp.hidden = !(current.compare > current.price);
        if (current.media) goTo(current.media);
      }
      if (atc) {
        atc.disabled = !current || !current.available;
        atcLabel.textContent = !current ? 'Unavailable' : current.available ? atcText : soldText;
      }
      subtotal(); mark(); sticky();
    }
    root.addEventListener('change', function (e) {
      if (e.target.closest('.pdp-option[data-option-index]')) onChange();
      if (e.target.name === 'quantity') subtotal();
    });

    function subtotal() {
      var el = root.querySelector('[data-subtotal]'); if (!el || !current) return;
      var q = form.querySelector('input[name="quantity"]:checked');
      el.textContent = W.money(current.price * (q ? +q.value : 1));
    }
    if (variants.length) mark();

    /* ----- gallery ----- */
    var thumbs = root.querySelectorAll('[data-thumb]'), idx = root.querySelector('[data-gallery-index]');
    function goTo(mediaId) {
      var fig = track && track.querySelector('[data-media-id="' + mediaId + '"]'); if (!fig) return;
      if (window.matchMedia('(min-width: 900px)').matches && !track.classList.contains('is-slider')) {
        fig.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      } else {
        track.scrollTo({ left: fig.offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }
      active(mediaId);
    }
    function active(mediaId) {
      thumbs.forEach(function (t) { var on = t.dataset.thumb === String(mediaId); t.classList.toggle('is-active', on); t.setAttribute('aria-current', on); });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { goTo(t.dataset.thumb); }); });
    if (track && 'IntersectionObserver' in window) {
      var figs = track.querySelectorAll('[data-media-id]');
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting && en.intersectionRatio > .6) {
            var i = Array.prototype.indexOf.call(figs, en.target);
            if (idx) idx.textContent = i + 1;
            active(en.target.dataset.mediaId);
          }
        });
      }, { root: window.matchMedia('(max-width: 899px)').matches ? track : null, threshold: [.6] });
      figs.forEach(function (f) { io.observe(f); });
    }

    /* ----- vehicle prefill from ?vehicle= or My garage ----- */
    var vIn = form.querySelector('[data-vehicle-input]');
    if (vIn) {
      var q = new URLSearchParams(location.search).get('vehicle');
      var g = W.getGarage && W.getGarage();
      if (q) vIn.value = q; else if (g && g.make) vIn.value = g.make + ' ' + g.model + (g.year ? ' (' + g.year + ')' : '');
    }
    // Validate required fields (the form is novalidate so errors show inline)
    form.addEventListener('submit', function (e) {
      var bad = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (f) { return !String(f.value).trim(); });
      if (!bad.length) return;
      e.preventDefault(); e.stopImmediatePropagation();
      bad.forEach(function (f) {
        f.setAttribute('aria-invalid', 'true');
        var id = f.id + '-error', err = document.getElementById(id);
        if (!err) { err = document.createElement('span'); err.className = 'error'; err.id = id; f.insertAdjacentElement('afterend', err); f.setAttribute('aria-describedby', id); }
        err.textContent = 'Please add your vehicle so we can confirm fitment.';
        f.addEventListener('input', function () { f.removeAttribute('aria-invalid'); err.textContent = ''; }, { once: true });
      });
      bad[0].focus();
    }, true);

    /* ----- spec chooser: "Let us spec it" / "I know my specs" ----- */
    var spec = root.querySelector('[data-spec-path]');
    if (spec && spec.dataset.specKind !== 'flow') {
      var SPEC = ['Size', 'ET', 'PCD', 'CB'];
      var HINTS = { Size: 'e.g. 20x9.5 front / 20x10.5 rear', ET: 'e.g. ET35 front / ET40 rear', PCD: 'e.g. 5x112', CB: 'e.g. 66.6' };
      var specVehicle = spec.querySelector('[data-vehicle-input]');
      var specErr = spec.querySelector('[data-spec-error]');
      var fallback = spec.querySelector('[data-spec-fallback]');
      var specMode = function () { var r = spec.querySelector('[data-spec-mode]:checked'); return r ? r.dataset.specMode : 'pro'; };
      // The options app (Easify) renders its own Size / ET / PCD / CB / Model boxes into the form after load
      var appInput = function (name) { return form.querySelector('.tpo_option-container input[name="properties[' + name + ']"]'); };
      var specInput = function (name) { return appInput(name) || fallback.querySelector('[data-name="properties[' + name + ']"]'); };
      var applySpec = function () {
        var m = specMode(), hasApp = false;
        SPEC.forEach(function (n) {
          var i = appInput(n); if (!i) return;
          hasApp = true;
          i.closest('.tpo_option-container').classList.toggle('spec-hidden', m !== 'own');
          if (!i.placeholder && HINTS[n]) i.placeholder = HINTS[n];
        });
        // Our own boxes only when the app isn't there. They get a name only while in use: a duplicate
        // properties[Size] etc. in the form stops the app adding to cart.
        var useOwn = !hasApp && m === 'own';
        fallback.hidden = !useOwn;
        fallback.querySelectorAll('input').forEach(function (i) {
          i.disabled = !useOwn;
          if (useOwn) i.name = i.dataset.name; else i.removeAttribute('name');
        });
        var model = appInput('Model');
        if (model) model.closest('.tpo_option-container').classList.add('spec-hidden');
        spec.querySelectorAll('[data-spec-panel]').forEach(function (p) { p.hidden = p.dataset.specPanel !== m; });
        spec.querySelectorAll('[data-spec-note]').forEach(function (p) { p.hidden = p.dataset.specNote !== m; });
        spec.querySelectorAll('[data-spec-pro]').forEach(function (i) { i.disabled = m !== 'pro'; });
      };
      // Keep the app's "Model" box (now hidden) in step with the vehicle, so orders read the same as before
      var mirrorVehicle = function () {
        var model = appInput('Model'); if (!model || !specVehicle || model.value === specVehicle.value) return;
        model.value = specVehicle.value;
        model.dispatchEvent(new Event('input', { bubbles: true }));
        model.dispatchEvent(new Event('change', { bubbles: true }));
      };
      spec.addEventListener('change', function (e) {
        if (!e.target.matches('[data-spec-mode]')) return;
        applySpec();
        specErr.hidden = true;
      });
      if (specVehicle) specVehicle.addEventListener('input', mirrorVehicle);
      var specTimer;
      new MutationObserver(function () {
        clearTimeout(specTimer);
        specTimer = setTimeout(function () { applySpec(); mirrorVehicle(); }, 60);
      }).observe(form, { childList: true, subtree: true });
      applySpec();
      // "I know my specs" needs at least a size and an offset
      form.addEventListener('submit', function (e) {
        if (specMode() !== 'own') return;
        var missing = ['Size', 'ET'].filter(function (n) { var i = specInput(n); return i && !String(i.value).trim(); });
        if (!missing.length) return;
        e.preventDefault(); e.stopImmediatePropagation();
        specErr.textContent = 'Add your size and offset, or choose “Let us spec it” and we’ll work them out for you.';
        specErr.hidden = false;
        specInput(missing[0]).focus();
      }, true);
    }

    /* ----- flow-formed spec chooser: the customer picks the size, we match bolt pattern + offset to their car ----- */
    if (spec && spec.dataset.specKind === 'flow') {
      var fit = W.fit;
      var optSets = Array.prototype.slice.call(root.querySelectorAll('.pdp-option[data-option-name]'));
      var pInfo = { options: optSets.map(function (fs) { return fs.dataset.optionName; }) };
      var optSet = function (re) { return optSets.filter(function (fs) { return re.test(fs.dataset.optionName); })[0] || null; };
      var sizeFs = optSet(/size|diam/i), pcdFs = optSet(/bolt|pcd/i), etFs = optSet(/offset|^et\b/i);
      // Options we don't match to the car (colour, finish) stay as the customer picked them
      var fixedFs = optSets.filter(function (fs) { return fs !== sizeFs && fs !== pcdFs && fs !== etFs; });
      var sizeIdx = sizeFs ? +sizeFs.dataset.optionIndex : -1;
      var fVehicle = spec.querySelector('[data-vehicle-input]'), vWrap = spec.querySelector('[data-spec-vehicle-wrap]');
      var matchEl = spec.querySelector('[data-spec-match]'), matched = spec.querySelector('[data-spec-matched]');
      var fErr = spec.querySelector('[data-spec-error]'), manualBtn = spec.querySelector('[data-car-manual]');
      var manual = false, car = null, carData = null, classLimits = null, picking = false, ok = false;
      // Until the customer picks a size themselves (or arrives on a specific variant), start on the best-fitting size
      var sizeTouched = /[?&]variant=/.test(location.search);
      var fMode = function () { var r = spec.querySelector('[data-spec-mode]:checked'); return r ? r.dataset.specMode : 'pro'; };
      var picked = function (fs) { var c = fs && fs.querySelector('input:checked'); return c ? c.value : null; };
      var keepsFixed = function (v) { return fixedFs.every(function (fs) { var p = picked(fs); return p === null || v.options[+fs.dataset.optionIndex] === p; }); };
      var mm = function (n) { return Math.abs(n) + ' mm'; };

      // Select a variant's values in the (hidden) bolt pattern / offset pickers, and the size too
      // when the customer hasn't chosen one; the variant picker does the rest
      var pick = function (v, withSize) {
        picking = true;
        optSets.forEach(function (fs) {
          if ((fs === sizeFs && !withSize) || fixedFs.indexOf(fs) > -1) return;
          var val = v.options[+fs.dataset.optionIndex];
          var inp = Array.prototype.filter.call(fs.querySelectorAll('input'), function (i) { return i.value === val; })[0];
          if (inp && !inp.checked) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
        });
        picking = false;
      };
      var match = function () {
        ok = false;
        matched.disabled = true;
        if (fMode() !== 'pro' || manual || !carData) { matchEl.hidden = true; return; }
        var size = picked(sizeFs);
        var forSize = variants.filter(function (v) { return (sizeIdx < 0 || !sizeTouched || v.options[sizeIdx] === size) && keepsFixed(v); });
        var best = fit.bestFlow(forSize, pInfo, carData, classLimits);
        var name = car.make + ' ' + car.model;
        if (best) {
          pick(best.variant, !sizeTouched);
          size = picked(sizeFs);
          ok = true;
          // No width or offset on the listing (bolt pattern only): nothing to place against factory
          var pl = best.place, placed = pl.dOut != null;
          var where = pl.dOut > 0 ? mm(pl.dOut) + ' further out than factory' : pl.dOut < 0 ? mm(pl.dOut) + ' further in than factory' : 'flush with factory';
          var spcd = picked(pcdFs) || best.sp.pcd, set = picked(etFs) || (best.sp.et != null ? best.sp.et + ' mm' : '');
          var lines = ['<strong>Matched to your ' + W.esc(name) + ':</strong> ' + W.esc(spcd) + ' bolt pattern' + (set ? ', ' + W.esc(set) + ' offset' : '') + '.' + (placed ? ' Sits about ' + where + '.' : '')];
          if (placed && pl.level === 1) lines.push('A firm fit: may need a guard roll. We confirm it with you before dispatch.');
          if (placed && pl.level === 2) lines.push('Beyond what factory guards take. Message us before ordering and we’ll suggest a size that fits.');
          if (best.smaller) lines.push('Smaller than your factory wheels: we check brake clearance before dispatch.');
          matchEl.className = 'spec-match ' + (placed && pl.level ? 'is-warn' : 'is-ok');
          matchEl.innerHTML = lines.map(function (l) { return '<p>' + l + '</p>'; }).join('');
          matched.value = 'Auto-matched to ' + name + ' (' + car.year + '): ' + (placed
            ? (pl.dOut >= 0 ? '+' : '−') + mm(pl.dOut) + ' out, ' + (pl.dIn >= 0 ? '+' : '−') + mm(pl.dIn) + ' in vs factory' + (pl.level ? ' (check)' : '')
            : spcd + ' bolt pattern (offset not on listing, check)');
          matched.disabled = false;
        } else {
          var pcd = fit.normPCD(carData.bolt), sizes = [], inPcd = function (v) { var sp = fit.parseVariant(v, pInfo); return v.available && sp.pcd && fit.normPCD(sp.pcd) === pcd; };
          if (sizeIdx > -1) variants.forEach(function (v) {
            var sz = v.options[sizeIdx];
            if (keepsFixed(v) && inPcd(v) && sizes.indexOf(sz) < 0) sizes.push(sz);
          });
          // Made in their bolt pattern, just not in the colour / finish they picked
          var otherFixed = !sizes.length && fixedFs.length && variants.some(inPcd);
          matchEl.className = 'spec-match is-bad';
          matchEl.innerHTML = sizes.length
            ? '<p>Not made in your ' + W.esc(carData.bolt) + ' bolt pattern at ' + W.esc(size) + '. Sizes that are:</p><div class="chip-row">' +
              sizes.map(function (z) { return '<button type="button" class="chip" data-spec-size="' + W.esc(z) + '">' + W.esc(z) + '</button>'; }).join('') + '</div>'
            : otherFixed
            ? '<p>Not made in your ' + W.esc(carData.bolt) + ' bolt pattern in this ' + W.esc(fixedFs.map(function (fs) { return fs.dataset.optionName.toLowerCase(); }).join(' / ')) + '. Try another one above, or message us.</p>'
            : '<p>This design isn’t made in your ' + W.esc(carData.bolt) + ' bolt pattern. <a href="' + W.fitmentHref(car.make, car.model, car.year) + '">See flow-formed wheels that fit your ' + W.esc(name) + '</a>.</p>';
        }
        matchEl.hidden = false;
      };
      var applyFlow = function () {
        var pro = fMode() === 'pro', auto = pro && !manual;
        [pcdFs, etFs].forEach(function (fs) { if (fs) fs.classList.toggle('spec-hidden', auto); });
        spec.querySelectorAll('[data-spec-panel]').forEach(function (el) { el.hidden = !pro || manual; });
        spec.querySelectorAll('[data-spec-note]').forEach(function (el) { el.hidden = el.dataset.specNote !== (pro ? 'pro' : 'own'); });
        vWrap.hidden = auto;
        fVehicle.required = !auto;
        fVehicle.setAttribute('aria-required', String(!auto));
        // The options app's free-text ET / CB boxes only make sense when the customer is choosing specs
        Array.prototype.forEach.call(form.querySelectorAll('.tpo_option-container input[name^="properties[ET"], .tpo_option-container input[name^="properties[CB"]'), function (i) {
          i.closest('.tpo_option-container').classList.toggle('spec-hidden', pro);
        });
        if (manualBtn) manualBtn.textContent = manual ? 'Pick my car from the list' : 'Car not listed? Type it in';
        fErr.hidden = true;
        match();
      };
      var setCar = function (v) {
        car = v && v.make && v.model && v.year ? v : null;
        carData = null;
        W.loadFitment().then(function (d) {
          if (car && d.DB[car.make] && d.DB[car.make][car.model]) carData = d.DB[car.make][car.model][car.year] || null;
          classLimits = carData && d.LIMITS ? d.LIMITS[carData.cls] : null;
          if (carData) {
            fVehicle.value = car.make + ' ' + car.model + ', ' + car.year;
            W.setGarage(car);
          }
          match();
        });
      };
      var carApi = W.vehicleSelects(spec, { onChange: setCar });

      spec.addEventListener('change', function (e) { if (e.target.matches('[data-spec-mode]')) applyFlow(); });
      root.addEventListener('change', function (e) { if (!picking && sizeFs && sizeFs.contains(e.target)) { sizeTouched = true; match(); } });
      matchEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-spec-size]'); if (!b) return;
        var inp = Array.prototype.filter.call(sizeFs.querySelectorAll('input'), function (i) { return i.value === b.dataset.specSize; })[0];
        if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
      });
      if (manualBtn) manualBtn.addEventListener('click', function () {
        manual = !manual;
        if (!manual && carData) fVehicle.value = car.make + ' ' + car.model + ', ' + car.year;
        applyFlow();
        (manual ? fVehicle : spec.querySelector('[data-vb="make"]')).focus();
      });
      // Re-run when the variant picker or options app changes the form; skip our own updates inside the
      // chooser (match note, button text), which would otherwise re-trigger this every 60 ms
      var reflow = W.debounce(function () { applyFlow(); }, 60);
      new MutationObserver(function (recs) {
        if (recs.some(function (r) { return !spec.contains(r.target); })) reflow();
      }).observe(form, { childList: true, subtree: true });
      // Start from the car in My garage, if there is one
      var g0 = W.getGarage && W.getGarage();
      if (g0 && g0.make && carApi) carApi.set(g0).then(function () { setCar(carApi.get()); });
      applyFlow();

      form.addEventListener('submit', function (e) {
        if (fMode() !== 'pro' || manual) return;
        var problem = !carData ? 'Pick your car so we can match the bolt pattern and offset, or tap “Car not listed?”.'
          : !ok ? (sizeFs && !fixedFs.length ? 'That size doesn’t come in your bolt pattern. Pick one of the sizes listed, or message us.' : 'That choice doesn’t come in your bolt pattern. Pick another option above, or message us.') : '';
        if (!problem) return;
        e.preventDefault(); e.stopImmediatePropagation();
        fErr.textContent = problem;
        fErr.hidden = false;
        var at = carData ? sizeFs : spec.querySelector('[data-vb="make"]');
        if (at) { at.scrollIntoView({ block: 'center' }); if (!carData) at.focus(); }
      }, true);
    }

    /* ----- sticky add to cart (mobile) ----- */
    var bar = document.querySelector('[data-sticky-atc]');
    function sticky() {
      if (!bar) return;
      var p = bar.querySelector('[data-sticky-price]'); if (p && current) p.textContent = W.money(current.price);
      var g = bar.querySelector('[data-sticky-go]'); if (g && atcLabel) g.textContent = atcLabel.textContent;
    }
    if (bar && atc && 'IntersectionObserver' in window) {
      var mq = window.matchMedia('(max-width: 899px)');
      new IntersectionObserver(function (es) {
        var show = mq.matches && !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        bar.hidden = !show; document.body.classList.toggle('has-sticky-atc', show);
      }).observe(atc);
      bar.querySelector('[data-sticky-go]').addEventListener('click', function () {
        atc.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { atc.focus(); }, 400);
      });
    }
  });
})();
